__turbopack_context__.v({
  "className": "EtSmBa_className",
  "variable": "EtSmBa_variable",
});
